import React from "react";
import "./css/about.css";

function About() {
  return (
    <div className="about">
      <div className="about_content">
        <p>
          <span className="bold">
            Welcome to Sweets Collection
          </span>
          <br></br>
          <br></br>The word "Sweets collection" itself describes the motto of this
          venture. It refers to the base products prepared in Madhwa Brahmins
          traditional food style. We are a humble Madhwa Brahmin family, trying
          to share authentic base products i.e Masala items required to prepare
          delicious Brahmin style recipes. The recipes for preparing the masala
          items is carried from generations and none of our products contain
          Onion, Garlic or any preservatives. Instead, Asafoetida(ಇಂಗು) plays a
          prime role in our products. Usually, all of our products are made
          without Onion and Garlic. However, due to customer demands, we are
          offering three items with Garlic. All our products are prepared in a
          hygienic and homely environment. All the products listed below are
          "MADE TO ORDER". Therefore, our food items delivered will be 100%
          fresh! All of our family members have stood strong and tested negative
          for COVID-19 in these challenging times. We are slowly expanding our
          menu as we scale up the venture and we highly appreciate your support
          and patience. We are planning to pen down our ancestral recipes under
          the Best Results section of every product. Follow these recipes to
          yield the most authentic Brahmin Delicacies. We will be updating this
          shortly. Apart from these products, we also undertake orders for
          Marriages and Upanayanas to prepare the required special items. Please
          contact us in person for bulk orders.
        </p>

        <p>
          <br></br>The word "Sweets collection" itself describes the motto of this
          venture. It refers to the base products prepared in Madhwa Brahmins
          traditional food style. We are a humble Madhwa Brahmin family, trying
          to share authentic base products i.e Masala items required to prepare
          delicious Brahmin style recipes. The recipes for preparing the masala
          items is carried from generations and none of our products contain
          Onion, Garlic or any preservatives. Instead, Asafoetida(ಇಂಗು) plays a
          prime role in our products. Usually, all of our products are made
          without Onion and Garlic. However, due to customer demands, we are
          offering three items with Garlic. All our products are prepared in a
          hygienic and homely environment. All the products listed below are
          "MADE TO ORDER". Therefore, our food items delivered will be 100%
          fresh! All of our family members have stood strong and tested negative
          for COVID-19 in these challenging times. We are slowly expanding our
          menu as we scale up the venture and we highly appreciate your support
          and patience. We are planning to pen down our ancestral recipes under
          the Best Results section of every product. Follow these recipes to
          yield the most authentic Brahmin Delicacies. We will be updating this
          shortly. Apart from these products, we also undertake orders for
          Marriages and Upanayanas to prepare the required special items. Please
          contact us in person for bulk orders.
        </p>

        <div class="contact-info">
          <p>
            <br />
            RISHI AGRAWAL : +91 7597649518
          </p>
          <p>RISHI AGRAWAL : +91 9352199632</p>
          <p>
            <a href="mailto:rishiagrawal0405@gmail.com">rishiagrawal0405@gmail.com</a>
          </p>
        </div>

        <p id="about_shipping">
          <br />
          Items will be made and shipped within 3 to 4 days after the order is
          confirmed. We accept payments through any of the UPI apps, that is
          Google Pay, Phone Pe and Paytm. We also accept Cash on Delivery. Our
          products are safely shipped by our shipping partner, ShipRocket that
          conclude shipping costs based on the State and City. Our international
          shipping is handled by the Govt. Post Office at a nominal fee.
        </p>

        <p id="refund">
          <br />
          As of now, we don't encourage cancellations and refunds as we cook
          everything fresh upon receiving orders. We never cook anything in bulk
          before receiving orders.
        </p>
      </div>
    </div>
  );
}

export default About;
